import $ from 'jquery'

let ll = 0;
let list = {};
async function uploadFile(file, progressDiv, classname) {

    // const fileInput = document.getElementById('fileInput');
    // const progressDiv = document.getElementById('progress');
    // const file = fileInput.files[0];
    const chunkSize = 1024 * 1024 * 5; // 1 MB chunk size
    const totalChunks = Math.ceil(file.size / chunkSize);


    if (file) {
        let start = 0;
        progressDiv.innerText = 'Preprocessing';
        console.log(1)
        let totalHash = await CalculateTotalHash(file);
        progressDiv.innerText = 'Preprocessed complete!';
        console.log(2)
        let totalHashHex = [];
        let flag = 0;
        progressDiv.innerText = 'Uploading';
        console.log(3)
        while (start < file.size) {
            const chunk = file.slice(start, start + chunkSize);
            console.log('chunk', chunk)
            const arrayBuffer = await readFileAsArrayBuffer(chunk);
            const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
            totalHashHex.push(hashHex);
            const formData = new FormData();
            formData.append('flag', totalChunks - flag)
            formData.append('file', chunk);
            formData.append('chunkHash', hashHex);
            formData.append('totalHash', totalHash);
            formData.append('classname', classname);

            start += chunkSize;
            flag++;
            let object = {};
            formData.forEach(function (value, key) {
                object[key] = value;
            });
            console.log(object)
            await sendChunk(formData, totalChunks, flag, totalHashHex);
            progressDiv.innerText = 'Upload complete!';
            console.log(4)
        }
    }
    else {
        progressDiv.innerText = 'No file selected';
    }
}

async function sendChunk(FormData, totalChunks, flag, totalHashHex) {
    const formData = FormData;
    if (formData.get("flag") === '1') {
        list["list"] = totalHashHex;
        console.log(totalHashHex);
    }
    console.log("list", list["list"]);
    console.log("chunk", formData.get('chunkHash'), formData.get('classname'))
    $.ajax({
        url: "https://app6132.acapp.acwing.com.cn/jdg/video/upload/",
        type: "POST",
        data: {
            event: "check",
            chunk: formData.get('chunkHash'),
            classname: formData.get('classname'),
        },
        success: async function (resp) {
            console.log(resp.event)
            if (resp.event === 'need') {
                const response = await fetch('https://app6132.acapp.acwing.com.cn/jdg/video/upload/', {
                    method: 'POST',
                    body: formData,
                });
                if (response.ok) {
                    const responseData = await response.json();
                    console.log(responseData);
                    if (responseData.event === "get") {
                        ll++;
                    }

                } else {
                    console.error('请求失败:', response.status);
                }
            }
            else if (resp.event === 'exist') {
                ll++;
            }
            if (ll === totalChunks) {

                console.log("send")
                setTimeout(function () {
                    $.ajax({
                        url: "https://app6132.acapp.acwing.com.cn/jdg/video/upload/",
                        type: "POST",
                        data: {
                            event: "merge",
                            chunklist: list["list"],
                            classname: formData.get('classname'),
                        },
                        success: function (resp) {
                            alert(resp.event);
                        }
                    })
                    list = {};
                    ll = 0;
                }, 2000)
            }
        }
    })

}

async function CalculateTotalHash(file) {
    // const file = fileInput.files[0];
    const chunkSize = 1024 * 1024 * 5; // 1 MB
    const totalChunks = Math.ceil(file.size / chunkSize);
    const chunkHashes = [];

    for (let currentChunk = 0; currentChunk < totalChunks; currentChunk++) {
        const start = currentChunk * chunkSize;
        const end = ((currentChunk + 1) * chunkSize) >= file.size ? file.size : (currentChunk + 1) * chunkSize;
        const chunk = file.slice(start, end);

        const chunkHashBuffer = await calculateHash(chunk);
        const chunkHashArray = Array.from(new Uint8Array(chunkHashBuffer));
        chunkHashes.push(chunkHashArray.map(byte => byte.toString(16).padStart(2, '0')).join(''));

    }

    const totalHashBuffer = await calculateMergedHash(chunkHashes);
    console.log(totalHashBuffer);
    return totalHashBuffer;
}

function calculateHash(chunk) {
    return chunk instanceof Blob ? readFileAsArrayBuffer(chunk) : 114;
}

function readFileAsArrayBuffer(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => resolve(event.target.result);
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
    });
}

async function calculateMergedHash(hashValues) {
    let concatenatedArray = new Uint8Array(0);

    for (const hashValue of hashValues) {
        const hashBuffer = await crypto.subtle.digest('SHA-256', stringToUint8Array(hashValue));
        const hashArray = new Uint8Array(hashBuffer);
        concatenatedArray = mergeUint8Arrays([concatenatedArray, hashArray]);
    }

    const buffer = await crypto.subtle.digest('SHA-256', concatenatedArray);
    const mergedHashArray = new Uint8Array(buffer);

    // 将 Uint8Array 转换为十六进制字符串
    const mergedHashHex = Array.from(mergedHashArray).map(byte => byte.toString(16).padStart(2, '0')).join('');

    return mergedHashHex;
}

// 辅助函数：将字符串转换为 Uint8Array
function stringToUint8Array(str) {
    const encoder = new TextEncoder();
    return encoder.encode(str);
}

function mergeUint8Arrays(arrays) {
    const totalLength = arrays.reduce((acc, array) => acc + array.length, 0);
    const result = new Uint8Array(totalLength);
    let offset = 0;

    arrays.forEach(array => {
        result.set(array, offset);
        offset += array.length;
    });
    return result;
}

export { uploadFile };